import { BpButton } from '../../../../shared/components/buttons/bp-button/BpButton'
import { hideModal } from '../../../../app/store/reducers/AppSlice'
import React from 'react'
import { useAppDispatch } from '../../../../app/store/hooks/Redux'
import { useTranslation } from 'react-i18next'
import clsx from 'clsx'
import styles from './UnsavedChangesModal.module.scss'

interface UnsavedChangesModalProps {
  onSave?: () => void
  onLeave: () => void
}

export const UnsavedChangesModal = ({ onSave, onLeave }: UnsavedChangesModalProps) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()

  return (
    <div className={clsx(styles.root)}>
      <p className={clsx(styles.title)}>{t('pages.project.unsavedChanges')}</p>
      <p className={clsx(styles.message)}>
        {t('pages.project.haveUnsavedChanges')}
      </p>
      <div className={clsx(styles.buttons)}>
        {onSave ? (
          <BpButton
            className={clsx(styles.button)}
            onClick={() => {
              dispatch(hideModal())
              onSave()
            }}
          >
            {t('buttons.saveChanges')}
          </BpButton>
        ) : (
          <BpButton
            className={clsx(styles.button)}
            onClick={() => {
              dispatch(hideModal())
            }}
          >
            {t('buttons.continue')}
          </BpButton>
        )}
        <BpButton
          className={clsx(styles.button)}
          theme={'outline'}
          onClick={() => {
            dispatch(hideModal())
            onLeave && onLeave()
          }}
        >
          {t('buttons.leaveAnyway')}
        </BpButton>
      </div>
    </div>
  )
}
